import { UmbrellaMemberRole } from '../../../../../../../query-api/umbrella-members-query'

export const getUserRoleIds = (roles?: UmbrellaMemberRole[]) => {
  return roles?.map((role) => role.roleId)
}
